import React from 'react';
import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomSelect = styled(({ MenuProps, ...props }) => (
  <Select
    {...props}
    MenuProps={{
      ...MenuProps,
      PaperProps: {
        ...MenuProps?.PaperProps,
        sx: {
          maxHeight: '50svh',
          boxShadow: '4px 4px 20px rgba(0, 0, 0, 0.2)',
          ...(MenuProps?.PaperProps?.sx || {})
        }
      }
    }}
  />
))(({ theme }) => ({
  '& .placeholder': {
    color: theme.palette.text.secondary,
    opacity: '0.8'
  },
  '& .MuiOutlinedInput-input::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '0.8'
  },
  '& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '1'
  },
  '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[200]
  }
}));

export default CustomSelect;
